import { apiDelete } from '../../utils/api';

export const deleteInvitation = (org_id, email, adm_action_annotation) => {
  return apiDelete(`/organization/${org_id}/invitation`, 'delete_invitation', {
    email,
    adm_action_annotation,
  });
};
